const env = process.env.VUE_APP_MODE;
const host = process.env.VUE_APP_HOST;
const dictionary = {
 
};

module.exports = { dictionary };
